import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { updateTourProgress } from '../../../store/session/action-creators'

const CREATE_TOUR_ID = 'tour.appeals.create.v1'
const CARD_TOUR_ID = 'tour.appeals.card.v1'

export function AppealCreateSuccessToast() {
  const { id } = useParams<{ id: string }>()
  const dispatch = useDispatch()
  const sessionData = useSelector((s: any) => s.session?.sessionData)
  const tours = (sessionData as any)?.jsonSettings?.tours || {}
  const progress = tours?.[CREATE_TOUR_ID] || {}
  const cardProgress = tours?.[CARD_TOUR_ID] || {}

  useEffect(() => {
    // показываем только после редиректа с /appeal/new на /appeal/:id
    if (!id || id === 'new') return
    if (progress?.stage !== 'waiting_save') return

    dispatch(
      updateTourProgress(CREATE_TOUR_ID, {
        stage: 'completed',
        completed: true,
      }) as any,
    )

    // Стартуем тур по карточке только после первого создания.
    if (
      !cardProgress?.completed &&
      cardProgress?.stage !== 'prompted' &&
      cardProgress?.stage !== 'in_progress'
    ) {
      dispatch(
        updateTourProgress(CARD_TOUR_ID, {
          stage: 'prompted',
          currentStep: 0,
          completed: false,
          createdAppealId: id,
          showCongrats: true,
        }) as any,
      )
    }
  }, [id, progress?.stage, dispatch, cardProgress?.completed, cardProgress?.stage])

  return null
}
